import { render } from "./OfferTrade.vue?vue&type=template&id=8c38844c"
import script from "./OfferTrade.vue?vue&type=script&lang=js"
export * from "./OfferTrade.vue?vue&type=script&lang=js"
script.render = render

export default script